/**
 * ResetPassword — self-service ustawienie nowego hasła z jednorazowego tokenu.
 *
 * Dostępne BEZ logowania (dla zablokowanych userów). Token z ?token= w URL.
 * Self-contained (window.location) — non-auth branch App.js nie ma routera.
 */

import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Loader2, CheckCircle2, KeyRound } from 'lucide-react';
import { api } from '../lib/api';

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (pw.length < 8) { setErr('Hasło musi mieć min. 8 znaków'); return; }
    if (pw !== pw2) { setErr('Hasła nie są identyczne'); return; }
    setBusy(true);
    try {
      await api.post('/auth/password-reset/confirm', { token, new_password: pw });
      setDone(true);
      setTimeout(() => { window.location.href = '/'; }, 2500);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Nie udało się ustawić hasła. Token mógł wygasnąć.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-6">
          <div className="flex items-center gap-2 mb-1">
            <KeyRound className="w-5 h-5 text-primary" />
            <h1 className="text-xl font-bold">Ustaw nowe hasło</h1>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Wprowadź nowe hasło do swojego konta MASKIL.
          </p>

          {!token ? (
            <div className="text-sm text-red-400">
              Brak tokenu w linku. Użyj pełnego linku resetu (z parametrem <code>?token=</code>).
            </div>
          ) : done ? (
            <div className="py-6 flex flex-col items-center gap-3 text-center">
              <CheckCircle2 className="w-12 h-12 text-emerald-500" />
              <p className="font-medium">Hasło ustawione!</p>
              <p className="text-sm text-muted-foreground">Przekierowanie do logowania…</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div>
                <label className="text-sm font-medium mb-1 block">Nowe hasło</label>
                <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                  placeholder="min. 8 znaków" autoFocus />
              </div>
              <div>
                <label className="text-sm font-medium mb-1 block">Powtórz hasło</label>
                <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                  placeholder="powtórz nowe hasło" />
              </div>
              {err && <div className="text-sm text-red-400">{err}</div>}
              <Button type="submit" className="w-full" disabled={busy}>
                {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Ustawianie…</> : 'Ustaw hasło'}
              </Button>
              <a href="/" className="block text-center text-xs text-muted-foreground hover:text-foreground">
                ← Powrót do logowania
              </a>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
